<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";

export default {
    name: "App",
    created() {
        this.Nosliding();
        this.NoDoubleClickSliding();
    },
    methods: {
        Nosliding() {
            //禁止滑动缩放
            document.documentElement.addEventListener(
                "touchstart",
                function(event) {
                    if (event.touches.length > 1) {
                        event.preventDefault();
                    }
                },
                false
            );
        },
        NoDoubleClickSliding() {
            //禁止双击放大
            var lastTouchEnd = 0;
            document.documentElement.addEventListener(
                "touchend",
                function(event) {
                    var now = Date.now();
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault();
                    }
                    lastTouchEnd = now;
                },
                false
            );
        }
    }
};
</script>

<style lang="less">
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue